/***************************************************************************************
* FileName      : Vendor.js
* Description   : 해와관리자 > 셀러관리 > 활동기록 > 신규요청
* Company       : (주)엘리그
* Author        : 박권희
* Created Date  : 2024.01.12
* Modifide Date : 
* Reference     : 
***************************************************************************************/
import React, { useState , useEffect } from 'react';
import { useVendorRecordQuery } from "../../../../api/hwadmin/storeApi";
import { useNavigate } from 'react-router-dom';
import SortComponent from "../../common/SortComponent2";
import PageSizeSelect from "../../common/PageSizeSelect";
import { extractYearMonthDayHourMinute2 } from '../../../mypage/Component/extractDateUtils';
import Pagination from '../../common/Pagination';

function Vendor()
{
    const navigate = useNavigate();
    const [ordering, setOrdering] = useState('-created_at');
    const [pageSize, setPageSize] = useState(10); 

    const { data, error, isFetching, page, setPage } = useVendorRecordQuery(ordering , pageSize);

    // 가입순 정렬 데이터 변화
    const handleOrderingChange = (event) => {
        setOrdering(event.target.value);
    };
  
    const handlePageSizeChange = (event) => {
        setPageSize(parseInt(event.target.value));
    };

    const handlePrevPage = () => {
        setPage(prevPage => prevPage - 1);
    };
    
    const handleNextPage = () => {
        setPage(prevPage => prevPage + 1);
    };

    console.log(data);
    

    return(
        <>
          <section className='McontentBox'>
            <div className='subTitle'>
                <div className=''>
                    <span>결과</span>
                    <span className='result-wrap'>
                        (총 <b className='sum-s-b'>{data?.totalCnt ? data?.totalCnt : 0}</b>개)
                    </span>
                </div>

                <div className='selectWrap'>
                    <SortComponent
                        ordering={ordering}
                        handleOrderingChange={handleOrderingChange}
                        newLabel="최근활동순"
                        oldLabel="오래된활동순"
                    />

                    <PageSizeSelect value={pageSize} onChange={handlePageSizeChange} />
                </div>
            </div>
    
            <div className='fixTable_wrap'>
                <table className='sTable' id='scrollTable'>
                    <colgroup>
                        {/* <col style="width:10%"/>
                        <col style="width:10%"/>
                        <col style="width:10%"/>
                        <col style="width:10%"/>
                        <col style="width:10%"/> */}
                    </colgroup>
                    <thead>
                        <tr>
                            <th>번호</th>
                            <th>상호</th>
                            <th>셀러ID</th>
                            <th>요청상태</th>
                            <th>처리</th>
                            <th>처리사유</th>
                            <th>활동일시</th>
                            <th>처리자</th>
                        </tr>
                    </thead>
                    <tbody>
                    {data?.data.map((vendor, index) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td>{vendor.vendor}</td>
                            <td>{vendor.manager_id}</td>
                            <td>{vendor.status}</td>
                            <td>{vendor.result}</td>
                            <td>{vendor.message}</td>
                            <td>{extractYearMonthDayHourMinute2(vendor.created_at)}</td>
                            <td>{vendor.manager}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </section>

    
        {/* 페이지내비게이션 */}
        <section className='mt-3'>
            <Pagination
                count={data?.totalCnt || 0}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                handlePrevPage={handlePrevPage}
                handleNextPage={handleNextPage}
            />
        </section>
        </>
    )
}

export default Vendor